export default "__VITE_ASSET__0823067b__"